import axios from 'axios'
import { CaseworkerActionType } from '../action-types'
import config from '../../config'
import { Dispatch } from 'redux'
import { ApiIncidentPreview, mapPreviewToListItem } from '../../ts/api-types'

interface ApiListResponse<T> {
    data: T[]
}

const { apiUrl } = config

export const setCaseworkerLoading = () => {
    return {
        type: CaseworkerActionType.SET_CASEWORKER_LOADING,
    }
}

export const setCaseworkerError = (message: string) => {
    return {
        type: CaseworkerActionType.SET_CASEWORKER_ERROR,
        payload: {
            message,
        },
    }
}

export const getOwnReports = (id: number) => async (dispatch: Dispatch) => {
    dispatch(setCaseworkerLoading())
    try {
        const res = await axios.get<ApiListResponse<ApiIncidentPreview>>(
            `${apiUrl}/v1/me/incidents?status=new,action+required,awaiting+response`
        )

        if (res.status !== 201 && res.status !== 200 && res.status !== 204) {
            return dispatch(
                setCaseworkerError('Something went wrong fetching the reports')
            )
        }

        return dispatch({
            type: CaseworkerActionType.GET_OWN_REPORTS,
            payload: res.data.data.map(mapPreviewToListItem),
        })
    } catch (error) {
        return dispatch(
            setCaseworkerError('Something went wrong fetching the reports')
        )
    }
}

export const getContactClosedReports = () => async (dispatch: Dispatch) => {
    dispatch(setCaseworkerLoading())

    try {
        const res = await axios.get<ApiListResponse<ApiIncidentPreview>>(
            `${apiUrl}/v1/me/incidents?status=solved,rejected&with=trashed`
        )

        if (res.status !== 201 && res.status !== 200 && res.status !== 204) {
            return dispatch(
                setCaseworkerError('Something went wrong fetching the reports')
            )
        }

        return dispatch({
            type: CaseworkerActionType.GET_CLOSED_REPORTS,
            payload: res.data.data.map(mapPreviewToListItem),
        })
    } catch (error) {
        return dispatch(
            setCaseworkerError('Something went wrong fetching the reports')
        )
    }
}

export const getSelf =
    () => async (dispatch: Dispatch, getState: () => any) => {
        dispatch(setCaseworkerLoading())

        const state: any = getState()

        const user = state.auth.user

        let includes

        // At the moment the plan information is only relevant for the client
        if (user.roles.includes('client')) {
            includes = 'organization,plan'
        } else {
            includes = 'organization'
        }

        try {
            const res = await axios.get(
                `${apiUrl}/v1/auth/identity?with=${includes}`
            )

            if (res.status !== 200) {
                return dispatch(
                    setCaseworkerError('Something went wrong please reload')
                )
            }

            return dispatch({
                type: CaseworkerActionType.GET_SELF,
                payload: res.data.data,
            })
        } catch (error) {
            return dispatch(
                setCaseworkerError('Something went wrong please reload')
            )
        }
    }

export const searchAllReports =
    (searchValue: string) => (dispatch: Dispatch) => {
        dispatch({
            type: CaseworkerActionType.SEARCH_ALL_CASES,
            payload: {
                searchValue,
            },
        })

        return dispatch({
            type: CaseworkerActionType.FILTER_ALL_CASES,
        })
    }

export const addStatusFilter = (status: string) => (dispatch: Dispatch) => {
    dispatch({
        type: CaseworkerActionType.ADD_STATUS_FILTER,
        payload: {
            status,
        },
    })

    return dispatch({
        type: CaseworkerActionType.FILTER_ALL_CASES,
    })
}

export const addCaseTypeFilter = (type: string) => (dispatch: Dispatch) => {
    dispatch({
        type: CaseworkerActionType.ADD_CASE_TYPE_FILTER,
        payload: {
            type,
        },
    })

    return dispatch({
        type: CaseworkerActionType.FILTER_ALL_CASES,
    })
}

export const removeAllFilters = () => (dispatch: Dispatch) => {
    dispatch({
        type: CaseworkerActionType.REMOVE_ALL_FILTERS,
    })
}

export const searchClosedReports = (searchValue: string) => {
    return {
        type: CaseworkerActionType.SEARCH_CLOSED_REPORTS,
        payload: {
            searchValue,
        },
    }
}
